import { makeVar, useReactiveVar } from '@apollo/client';

type SetDraggingNodeId = (draggingNodeId: string) => void;

const draggingNodeIdVar = makeVar<string>('');

function setDraggingNodeId(draggingNodeId) {
  draggingNodeIdVar(draggingNodeId);
}

export function useDraggingNodeIdOperations(): {
  setDraggingNodeId: SetDraggingNodeId;
} {
  return { setDraggingNodeId };
}

export function useIsNodeDragged(): boolean {
  const draggingNodeId = useReactiveVar(draggingNodeIdVar);

  return Boolean(draggingNodeId);
}

export default function useDraggingNodeId(): [string, SetDraggingNodeId] {
  const draggingNodeId = useReactiveVar(draggingNodeIdVar);

  return [draggingNodeId, setDraggingNodeId];
}
